module.exports = __webpack_public_path__ + "static/media/fechar.429d3420.svg";